<template>
    <div class="sub-plans-page">
        <div class="d-flex flex-column w-100">
            <div class="sub-header">
                <div>
                    <span class="head-name">Your Hedlyner Subscription</span><br />
                    <span class="head-name" v-if="!isAuthed"
                        >for <span class="venue-check">Venue</span></span
                    >
                </div>
            </div>
            <div class="d-flex divider my-5"></div>
            <div class="current-plan" v-if="!isAuthed">
                <span class="plan-cond">
                    Sign Up for a free month trial period to unlock more features</span
                >
            </div>
            <div v-if="currentSubscriptionPlan === 'VenueFree'" class="free-info">
                <div><span class="your-plan-sub">Your plan</span></div>
                <div>
                    <span class="your-plan-sub" :style="planColor">{{ getPlanName }}</span>
                </div>
                <div
                    v-if="currentSubscriptionPlan === 'VenueFree' && !userHadTrial"
                    class="plan-cond"
                >
                    Activate your free trial period to unlock more features
                </div>
            </div>
            <div v-if="currentSubscriptionPlan !== 'VenueFree'">
                <div class="subs-rows">
                    <div class="rows-plan">
                        <div class="form-for-plan">
                            <div class="your-plan-sub">Your plan</div>
                            <div class="your-plan-sub" :style="planColor">
                                {{ getPlanName }}
                            </div>
                        </div>
                        <div class="form-for-plan">
                            <div class="your-plan-sub">Billing cycle</div>
                            <div class="sub-info">
                                {{ infoSubs.interval === 'year' ? 'Yearly' : 'Monthly' }}
                            </div>
                        </div>
                    </div>
                    <div class="rows-plan">
                        <div class="form-for-plan">
                            <div class="your-plan-sub">Trial period</div>
                            <div class="sub-info">
                                {{ trialPeriod }}
                            </div>
                        </div>
                        <div class="form-for-plan">
                            <div class="your-plan-sub">Next billing date:</div>
                            <div class="sub-info">{{ nextBillingDate }}</div>
                        </div>
                    </div>
                    <div class="rows-plan">
                        <div class="form-for-plan">
                            <div class="your-plan-sub">Payment</div>
                            <div class="sub-info">${{ infoSubs.monthly_price / 100 }}</div>
                        </div>
                        <div class="form-for-plan">
                            <div class="your-plan-sub">Payment card</div>
                            <div class="sub-info">
                                {{ paymentCard.brand }} {{ paymentCard.last4 }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <VenueSubCard
                :isAuthed="isAuthed"
                :plans="plans"
                :currentSubscriptionPlan="currentSubscriptionPlan"
                :userHadTrial="userHadTrial"
            />
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import { api } from '@/helpers/api'
    import { SubMixin } from '../../mixins/subscription/subscriptions'
    import VenueSubCard from './parts/VenueSubCard.vue'

    export default {
        name: 'SubVenuePlan',
        mixins: [SubMixin],
        components: {
            VenueSubCard
        },
        data() {
            return {
                isAuthed: Boolean,
                userHadTrial: false,
                plans: [],
                currentSubscriptionPlan: '',
                paymentCard: {},
                infoSubs: {},
                subscriptionHistory: null
            }
        },
        methods: {
            updateToPro() {
                this.showModal()
                this.plan = this.plans.filter((plan) => plan.name === 'VenuePro')[0]
            },
            async checkAuth() {
                try {
                    const data = await api(
                        {
                            method: 'get',
                            url: '/api/check-authorization'
                        },
                        { error: false }
                    )

                    this.isAuthed = data.isAuthorized
                } catch {
                    this.isAuthed = false
                }
            },
            async checkSub() {
                const data = await api({
                    method: 'get',
                    url: '/api/profile/stripe/get-plans'
                })
                this.plans = data.data
            },
            async getUserPlan() {
                const data = await api({
                    method: 'get',
                    url: '/api/profile/stripe/user/get-plan/venue'
                })
                this.currentSubscriptionPlan = data.subscription.plan_name
                this.paymentCard = data.card
                this.infoSubs = data.subscription
                this.userHadTrial = data.user_had_trial_period
                this.subscriptionHistory = data.subscriptionHistory?.length
            }
        },
        computed: {
            hideTrialInfo() {
                return this.subscriptionHistory > 2
            },
            trialPeriod() {
                return this.hideTrialInfo
                    ? 'Ended'
                    : `${this.proTrialEnds} ${this.infoSubs.trial_ends}`
            },
            nextBillingDate() {
                if (this.hideTrialInfo) {
                    const billingDate = new Date(this.infoSubs.next_bill_date)
                    if (this.infoSubs.interval === 'year') {
                        billingDate.setFullYear(billingDate.getFullYear() + 1)
                    } else {
                        billingDate.setMonth(billingDate.getMonth() + 1)
                    }
                    return billingDate.toDateString().split(' ').slice(1, 4).join(' ')
                } else {
                    return this.infoSubs.next_bill_date
                }
            },
            proTrialEnds() {
                const trialEndsDate = moment(this.infoSubs.trial_ends, 'MMMM DD, YYYY')
                const today = moment()
                return today.isSameOrBefore(trialEndsDate, 'day') ? 'Ends' : 'Ended'
            },
            getPlanName() {
                if (this.currentSubscriptionPlan) {
                    return this.subPlans.filter(
                        (plan) => plan.subscriptionName === this.currentSubscriptionPlan
                    )[0].planName
                } else {
                    return ''
                }
            },
            planColor() {
                return this.getPlanName === 'Basic' ? 'color: #cdeb09' : 'color: #d8b500;'
            }
        },
        async created() {
            await this.checkAuth()
            await this.checkSub()
            await this.getUserPlan()
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .sub-info-free {
        color: $lighter-grey;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
    }
    .free-info {
        @include flex-col;
        align-items: flex-start;
        gap: 16px;
    }
    .sub-info {
        overflow: hidden;
        color: $white-3;
        text-overflow: ellipsis;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
    }
    .form-for-plan {
        @include flex-col;
        align-items: flex-start;
        gap: 6px;
        flex: 1 0 0;
    }
    .subs-rows {
        @include flex-col;
        align-items: flex-start;
        gap: 24px;
        align-self: stretch;
    }
    .rows-plan {
        @include flex-start;
        gap: 24px;
        align-self: stretch;
    }
    .modal-subscriptions {
        align-items: center;
        background-color: $black-3;
        border: 1px solid $black-3;
        border-radius: 15px;
        display: flex;
        min-height: 638px;
        justify-content: center;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 9999;
    }
    .current-plan {
        @include flex-col;
        align-items: flex-start;
        gap: 16px;
    }
    .your-plan-sub {
        color: $lighter-grey;
        @include base-font-16;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    .plan-cond {
        color: $lighter-grey;
        @include base-font-16;
        font-weight: 550;
        line-height: 125%;
    }
    .venue-check {
        color: $violet;
        @include base-font-44;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .sub-plans-page {
        @include flex-col;
        align-items: center;
        padding: 90px 80px;
        gap: 96px;
    }
    .sub-header {
        @include flex-row;
        justify-content: space-between;
        align-items: center;
    }
    .head-name {
        color: $white-2;
        text-align: center;
        @include base-font-44;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    @media screen and (max-width: 980px) {
        .sub-plans-page {
            padding: 16px 0px 16px 0px;
        }
        .sub-header {
            flex-direction: column !important;
            gap: 20px;
            align-items: flex-start;
        }
        .current-plan {
            padding-bottom: 16px;
        }
    }
</style>
